module.exports = __webpack_public_path__ + "static/media/friluftsomrade.511f39fd.svg";